<template>
<div class="chapter">
<div class="inner_page">
<p class="right" id="Page_61"><span>51</span></p>
<p class="ct1" id="d7e691461"><span><a href="#/Lind_9781595554796_epub_c4_r1#d6e9" id="d7e9"><span class="small">Part 2</span><br/><br/><i>Joy </i></a></span></p>
<p class="epigraph" id="d7e692261"><span><i>See golden days, fruitful of golden deeds, with joy and love triumphing.</i></span></p>
<p class="extbd" id="d7e692761"><span>—J<span class="small">OHN </span>M<span class="small">ILTON </span></span></p>
<p class="epigraph" id="d7e693261"><span><i>Joyful, joyful we adore Thee, <br/> 
God of glory, Lord of love; <br/> 
Hearts unfold like flowers before Thee, <br/> 
opening to the sun above. <br/> 
Melt the clouds of sin and sadness, <br/> 
drive the dark of doubt away; <br/> 
Giver of immortal gladness, <br/> 
fill us with the light of day.</i></span></p>
<p class="extbd" id="d7e696161"><span>—H<span class="small">ENRY </span>V<span class="small">AN </span>D<span class="small">YKE </span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lind_9781595554796_epub_c13_r1.vue?9833bcc6